import { Col, Row, Spin } from 'antd';
import StatisticCard from 'components/statisticCard';
import LineChart from 'components/charts/lineChart';
import { useTranslation } from 'react-i18next';
import useStatisticaUser from './useStatisticaUser';
import Filters from '../../../../../components/filters';

const UserStatisticsView = () => {
  const { t } = useTranslation();
  const { data, loading, filters } = useStatisticaUser();
  return (
    <Spin spinning={loading}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Filters hideClearAll filters={filters} />
          <br />
        </Col>
        <Col span={6}>
          <StatisticCard
            big
            count={data.users_count}
            text={t('Utenti iscritti')}
          />
        </Col>
        <Col span={6}>
          <StatisticCard
            big
            count={data.users_with_order_count}
            text={t('Utenti che hanno effettuato ordini')}
          />
        </Col>
        <Col span={12}>
          <LineChart
            colors={['#D9322E']}
            title={t('Evoluzione temporale utenti iscritti')}
            tableData={[]}
            data={data.lineChartData}
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default UserStatisticsView;
